import React, { useEffect, useState } from "react";
import testwrap from 'assets/icons/brain.png'
import { getSurveyData } from "service/SurveyService";
import closeicon from 'assets/icons/lock.png'
import openicon from 'assets/icons/unlock.png'
import styles from "./SurveyBody.module.scss";
import moment from 'moment';
import { useNavigate } from 'react-router-dom'
const SurveyBody = ({ data, isadmin, log=null }) => {
  const navigate = useNavigate()
 
  const [render, setRender] = useState(false)


  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });

  useEffect(() => {

    setRender(false)

  }, [render]);

  const handleClick = (id) => {
    // Ensure that the navigation happens only on a button click
    if (typeof id !== "undefined") {
      navigate(`/survey/`, { state: { usedId: id } });
    }
  };
  const handleClickSurvey = (id) => {
    // Ensure that the navigation happens only on a button click
    if (typeof id !== "undefined") {
      navigate(`/usesurvey/`, { state: { usedId: id } });
    }
  };

  const formatDate = (dateString) => {
    const date = moment(dateString, 'DD.MM.YYYY HH:mm');
    const today = moment();

    if (date.isSame(today, 'day')) {
      return date.format('Сегодня HH:mm');
    }
    else if (date.isSame(today, 'year')) {
      return date.format('DD MMMM HH:mm')
    }
    else {
      return date.format('DD MMMM YYYY HH:mm');
    }
  };

  return (
    <div>
      {data?.length === 0 ? (
        <div style={{
          padding: '48px 24px',
          textAlign: 'center',
          background: '#FFFFFF',
          borderRadius: '12px',
          border: '2px solid #F5F5F5'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            margin: '0 auto 20px',
            background: 'linear-gradient(135deg, #FFE5D9 0%, #FFD5C5 100%)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '40px'
          }}>📊</div>
          <h3 style={{ color: '#333333', margin: '0 0 12px 0', fontSize: '20px', fontWeight: '700' }}>
            {log === 0 ? 'Нет пройденных анкет' : isadmin ? 'Нет созданных анкет' : 'Нет доступных анкет'}
          </h3>
          <p style={{ color: '#999999', margin: 0, fontSize: '15px' }}>
            {isadmin && log !== 0 ? 'Создайте первую анкету, чтобы начать работу' : 'Пока нет анкет в этом разделе'}
          </p>
        </div>
      ) : (
        <div className={styles.survey_card_wrapper}>
          <div className={styles.survey_table_header}>
            <span>Название</span>
            {log !== 0 && isadmin && <span>Статус</span>}
            {log === 0 && <span>Время</span>}
            <span>{log === 0 ? 'Автор' : 'Дата'}</span>
            <span>Действия</span>
          </div>
      {(log === 0) ? (
        <>  
          {[...data].map((item) => (
            <div key={item.id || item.survey} className={styles.survey_card}>
              <div>
                <p className={styles.title_survey}>
                  <img src={testwrap} className={styles.img} alt="Анкета" />
                  {item.employee_part_survey_title}
                </p>
                {item.description && (
                  <p className={styles.description_text}>
                    {item.description}
                  </p>
                )}
              </div>
              <div className={styles.date_info}>
                <p className={styles.date_text}>⏱️ {item.time_response}</p>
              </div>
              <div className={styles.date_info}>
                <p className={styles.employee_name}>{item.employee_name}</p>
              </div>
              <div className={styles.action_buttons}>
                <button 
                  className={styles.open_btn} 
                  onClick={() => handleClickSurvey(item.survey)}
                >
                  Просмотреть
                </button>
              </div>
            </div>
          ))}
        </>
      ) : (
        <>
          {[...data].map((item) => (
            <div key={item.id} className={styles.survey_card}>
              <div>
                <p className={styles.title_survey}>
                  <img src={testwrap} className={styles.img} alt="Анкета" />
                  {item.title}
                </p>
                {item.description && (
                  <p className={styles.description_text}>
                    {item.description}
                  </p>
                )}
              </div>
              {isadmin && (
                <div>
                  <span className={`${styles.status_badge} ${item.activate ? styles.active : styles.inactive}`}>
                    <img
                      src={item.activate ? openicon : closeicon}
                      className={styles.img_status}
                      alt={item.activate ? "Открыт" : "Закрыт"}
                    />
                    {item.activate ? "Открыт" : "Закрыт"}
                  </span>
                </div>
              )}
              <div className={styles.date_info}>
                <p className={styles.employee_name}>{item.employee_name}</p>
                <p className={styles.date_text}>{formatDate(item.createdAt)}</p>
              </div>
              <div className={styles.action_buttons}>
                {isadmin ? (
                  <button 
                    className={styles.open_btn} 
                    onClick={() => handleClick(item.id)}
                  >
                    Смотреть
                  </button>
                ) : (
                  <button 
                    className={styles.open_btn} 
                    onClick={() => handleClickSurvey(item.id)}
                  >
                    Пройти
                  </button>
                )}
              </div>
            </div>
          ))}
        </>
      )}
        </div>
      )}
    </div>
  );
};

export default SurveyBody;
